/* I am a webpack entry! */

import Vue from 'vue';
import App from './App.vue';

import commonObj from 'commonObj';
Vue.prototype.$commonObj = commonObj

// 需要图片延迟加载请取消注释 lazysizes
// import 'lazysizes';

// 需要消除点击延迟请取消注释 fastclick
// import FastClick from 'fastclick';
// FastClick.attach(document.body);

// 一些 njwap 项目需要的初始化操作
import '@module/helper/init';

import '@cdn_css/index.scss';

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount('#app');
